import React, { Component } from 'react';

import { HorizontalLine } from './HorizontalLine';
import {PageBlock} from './PageBlock';
import axios from 'axios';
import Cookies from 'universal-cookie'; 


export class Pages extends React.Component {
    
    state = {
        items : []
        
    }
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        const cookies = new Cookies();
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetUserPagesInfo', {
                    headers: {
                    'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                    }
                }).then(res => {
                    //projects = res.data.projects
                   
                    
                    
                        this.setState( {
                            project_name: res.data[0].project_name,
                            items : res.data
                        });
                   
                    

                })
                .catch(err => {
                    console.log(err);
                    

                })
        
        
        
        
    }

    delete(alias) {
         
        const cookies = new Cookies();
        axios.post(process.env.REACT_APP_BACKEND_SERVER + '/DeletePage/',
                 {
                     alias : alias
                 }, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    } // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                if (res.data.status == 'ok') {
                    window.location.reload()
                }
            })

    }

    render() {
        return (
            
                <div className='createPage'>
                        <h1> Созданные подписные страницы</h1>
                        <HorizontalLine />
                        <div className='pages_pagesBlock'>
                            
                            {
                            this.state.items.map(item => {
                                return (
                                    <PageBlock 
                                    confirmMsg = {"Вы уверены, что хотите удалить страницу и все статистические данные?"}
                                    delete={this.delete}
                                    alias = {item.alias}
                                    page_name={item.page_name}
                                    big_img_src={item.big_img_src} 
                                    cnt_sub={item.cnt_sub}
                                    total_views={item.total_views}
                                    is_active={true} />
                                );
                                })
                                }
                        </div>
                
                </div>

            
                 
        )
    }
}